import { render } from "./folderIcon.svg?vue&type=template&id=08c5e611"
const script = {}
script.render = render

export default script